const getWeekdays = (language, profileInsights) => {
  const today = new Date();
  let weekdayData = [];
  const options = { day: '2-digit', month: 'short' };

  const todayLabel = language === 'ar' ? 'اليوم' : 'Today';

  // Helper function to normalize date to YYYY-MM-DD for accurate comparison
  const normalizeDate = (date) => {
    const d = new Date(date);
    return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
  };

  for (let i = 0; i < 15; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);

    const formattedDate = i === 0
      ? todayLabel
      : new Intl.DateTimeFormat(language === 'ar' ? 'ar-AR' : 'en-GB', options).format(date);

    // Normalize the target date for comparison
    const normalizedTargetDate = normalizeDate(date);

    const filterInsights = profileInsights.filter((e) => {
      if (!e.viewed_at) return false;
      // Normalize the viewed_at date for comparison
      const normalizedInsightDate = normalizeDate(new Date(e.viewed_at));
      return normalizedInsightDate === normalizedTargetDate;
    });

    weekdayData.push({
      day: formattedDate,
      value: filterInsights.length,
    });
  }

  return weekdayData.reverse();
};

const getYearsData = (language, profileInsights) => {
  const currentYear = new Date().getFullYear();
  let yearsData = [];
  for (let i = 0; i < 10; i++) {

    const filterInsights = profileInsights.filter((e) => {
      const viewedAtYear = new Date(e.viewed_at).getFullYear();

      return viewedAtYear == currentYear - i;
    });
    yearsData.push({
      year: currentYear - i,
      value: filterInsights.length
    });
  }
  return yearsData.reverse();
};

const getMonthlyData = (language, profileInsights) => {
  const months = language === 'ar' ? ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'] : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  return months.map((month, index) => {
    const filterInsights = profileInsights.filter((e) => {
      const filterInsightsMonth = new Date(e.viewed_at).getMonth();
      return filterInsightsMonth === index;
    });
    return ({
      month: month,
      value: filterInsights.length,
    })
  });
};

const getWeeklyData = (language, profileInsights) => {
  const currentDate = new Date();

  const weeks = language === 'ar'
    ? ['الأسبوع 1', 'الأسبوع 2', 'الأسبوع 3', 'الأسبوع 4', 'الأسبوع 5', 'الأسبوع 6', 'الأسبوع 7', 'الأسبوع 8', 'الأسبوع 9']
    : ['Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5', 'Week 6', 'Week 7', 'Week 8', 'Week 9'];

  let weeklyData = [];

  // Helper function to calculate the week number of a given date
  const getWeekNumber = (date) => {
    const d = new Date(date);
    const firstDayOfMonth = new Date(d.getFullYear(), d.getMonth(), 1);
    const diffInDays = Math.floor((d - firstDayOfMonth) / (24 * 60 * 60 * 1000));
    return Math.floor(diffInDays / 7);
  };

  // Get the current week number
  const currentWeekNumber = getWeekNumber(currentDate);

  for (let i = 0; i < 9; i++) {
    const filteredInsights = profileInsights.filter((e) => {
      const viewedAtDate = e.viewed_at ? new Date(e.viewed_at) : null;
      if (viewedAtDate) {
        const viewedWeekNumber = getWeekNumber(viewedAtDate);
        return currentWeekNumber - viewedWeekNumber === i; // Match the week offset
      }
      return false;
    });

    weeklyData.push({
      week: i === 0 ? (language === 'ar' ? 'هذا الأسبوع' : 'This week') : weeks[i],
      value: filteredInsights.length,
    });
  }

  return weeklyData.reverse(); // Reverse to show the most recent week first
};

const getCustomData = (language, profileInsights, startDate, endDate) => {
  if (startDate && endDate) {
    const normalizeDate = (date) => {
      const d = new Date(date);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    };

    const start = normalizeDate(startDate);
    const end = normalizeDate(endDate);

    const customData = profileInsights.filter((e) => {
      const viewedDate = normalizeDate(e.viewed_at);
      return viewedDate >= start && viewedDate <= end;
    });

    const groupedData = customData.reduce((acc, insight) => {
      const day = normalizeDate(insight.viewed_at);
      acc[day] = (acc[day] || 0) + 1;
      return acc;
    }, {});

    const data = Object.entries(groupedData).map(([day, value]) => ({
      day,
      value
    }));

    return data.reverse();
  }
};

export const dataset = (language, profileInsights, startDate, endDate) => {
  return ({
    daily: getWeekdays(language, profileInsights),
    weekly: getWeeklyData(language, profileInsights),
    monthly: getMonthlyData(language, profileInsights),
    yearly: getYearsData(language, profileInsights),
    custom: getCustomData(language, profileInsights, startDate, endDate)
  });
}; 